export const formatDate = (date, format = "DD-MM-YYYY") => {
  if (!date) return "";

  const d = new Date(date);

  if (isNaN(d.getTime())) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  switch (format) {
    case "DD-MM-YYYY":
      return `${day}-${month}-${year}`;

    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;

    case "MM-DD-YYYY":
      return `${month}-${day}-${year}`;

    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;

    case "MMMM DD, YYYY":
      return d.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });

    default:
      return `${day}-${month}-${year}`;
  }
};
